import { useState } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import AppFooter from './tools/AppFooter';
import { MantineProvider, AppShell } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import { Navbar } from './tools/Navbar';

import { Notifications } from '@mantine/notifications';
import { UserProvider } from './tools/Context';

import HeaderApp from './tools/HeaderApp';
import UserManagement from './route/UserManagement';
import CreateModel from './route/CreateModel';
import DefineData from './route/DefineData';
import RetrieveData from './route/RetrieveData';
import GetProof from './route/GetProof';
import SaveDocument from './route/SaveDocument';
import FileToHash from './route/FileToHash';
import VerifyDocument from './route/VerifyDocument';
import DisplayProofPage from './route/DisplayProofPage';
import MyModel from './route/MyModel';
import MyAttestations from './route/MyAttestations';

function App() {
  const [userExist, setUserExist] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  return (
    <BrowserRouter>
      <UserProvider>
        <MantineProvider defaultColorScheme="light">
          <AppShell
            navbar={{
              width: userExist ? 310 : 0,
              breakpoint: 'sm'
            }}
            header={{ height: 60 }}
            footer={{ height: 60 }}
            padding="md">
            <AppShell.Header>
              <HeaderApp />
            </AppShell.Header>

            <Navbar setUserExist={setUserExist} setIsAdmin={setIsAdmin} />

            <Notifications />

            <AppShell.Main>
              <Routes>
                <Route path="/proof" element={<DisplayProofPage />} />
                <Route path="/createmodel" element={<CreateModel />} />
                <Route path="/definedata" element={<DefineData />} />
                <Route path="/retrievedata" element={<RetrieveData />} />
                <Route path="/getproof" element={<GetProof />} />
                <Route path="/mymodel" element={<MyModel />} />
                <Route path="/savedocument" element={<SaveDocument />} />
                <Route path="/filetohash" element={<FileToHash />} />
                <Route path="/verifydocument" element={<VerifyDocument />} />
                <Route path="/manageusers" element={<UserManagement />} />
                <Route path="/myattestations" element={<MyAttestations />} />
              </Routes>
            </AppShell.Main>

            <AppShell.Footer p="md">
              <AppFooter />
            </AppShell.Footer>
          </AppShell>
        </MantineProvider>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
